module.exports = __webpack_public_path__ + "img/no-img-profile.8cc0ee9f.svg";